import { namespace, backendDocType, schema, docPrivilege } from './config'
import loader, { queryManifest, generateReferenceDoc } from './loader'
import listview, { useTranspile } from './listview'
import { addViewManifest } from '../Config'

const manifest = {
  loader,
  schema,
  namespace,
  backendDocType,
  privilege: docPrivilege,
  queryManifest,
  useTranspile,
  generateReferenceDoc,
  listview,
  order: 0,
}

addViewManifest(manifest)
